/* Sun Energy Depot redesign: collection filter panel (mobile open/close) */
(function () {
  'use strict';
  if (window.__sdFilters) return;
  window.__sdFilters = true;
  const panel = () => document.getElementById('SedFilters');
  function open() {
    const p = panel();
    if (!p) return;
    p.classList.add('open');
    document.body.classList.add('overflow-hidden');
    document.querySelectorAll('[data-sd-filters-open]').forEach((b) => b.setAttribute('aria-expanded', 'true'));
    const c = p.querySelector('.sd-filters-mhead [data-sd-filters-close]');
    if (c) c.focus();
  }
  function close() {
    const p = panel();
    if (!p || !p.classList.contains('open')) return;
    p.classList.remove('open');
    document.body.classList.remove('overflow-hidden');
    document.querySelectorAll('[data-sd-filters-open]').forEach((b) => b.setAttribute('aria-expanded', 'false'));
  }
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-sd-filters-open]')) { e.preventDefault(); open(); return; }
    if (e.target.closest('[data-sd-filters-close]')) {
      e.preventDefault();
      close();
      const r = document.querySelector('.sd-results');
      if (r && window.innerWidth <= 760) window.scrollTo({ top: r.getBoundingClientRect().top + window.scrollY - 12, behavior: 'smooth' });
      return;
    }
    const p = panel();
    if (p && p.classList.contains('open') && !p.contains(e.target)) close();
  });
  document.addEventListener('keyup', (e) => { if (e.key === 'Escape') close(); });
})();